import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

/**
 * Wrapper :
 *  Wrapper for MenuList in Notebook/MenuList
 */
export function Wrapper(props) {
  const className = `${style.wrap} ${props.className}`;
  return <div 
    className={className}
    role="navigation"
    aria-label="Section index"
  >{props.children}</div>;
}

Wrapper.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Child components
   */
  children: PropTypes.array,
};

Wrapper.defaultProps = {
  className: '',
};
